module.exports = __webpack_public_path__ + "static/img/p2.037dbdb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/partner/p2.png
// module id = hekv
// module chunks = 0